import { render, staticRenderFns } from "./OrangeInit.vue?vue&type=template&id=672d754c&scoped=true&"
import script from "./OrangeInit.vue?vue&type=script&lang=js&"
export * from "./OrangeInit.vue?vue&type=script&lang=js&"
import style0 from "./OrangeInit.vue?vue&type=style&index=0&id=672d754c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d754c",
  null
  
)

export default component.exports